import { render, staticRenderFns } from "./CrmFiltros.vue?vue&type=template&id=180ad619&"
import script from "./CrmFiltros.vue?vue&type=script&lang=js&"
export * from "./CrmFiltros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports